import { DesignSystemPrimitive } from 'designSystem/types';
import { resolveTokenValue } from 'designSystem/tokens/resolver';
import * as S from './styles';

interface FormPrimitivePreviewProps {
	primitive: DesignSystemPrimitive;
}

export const FormPrimitivePreview = ({ primitive }: FormPrimitivePreviewProps) => {
	// Create inline styles from CSS properties, resolving token references
	const inlineStyles: React.CSSProperties = {};
	primitive.properties.forEach((prop) => {
		const cssProp = prop.name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		const resolvedValue = resolveTokenValue(prop.value);
		if (cssProp === 'borderRadius') {
			inlineStyles.borderRadius = resolvedValue;
		} else if (cssProp === 'border' || cssProp === 'borderColor') {
			inlineStyles.border = resolvedValue;
		} else if (cssProp === 'padding') {
			inlineStyles.padding = resolvedValue;
		} else if (cssProp === 'background' || cssProp === 'backgroundColor') {
			inlineStyles.background = resolvedValue;
		} else if (cssProp === 'fontSize') {
			inlineStyles.fontSize = resolvedValue;
		}
	});

	const isInput =
		primitive.baseSelector.includes('input') || primitive.baseSelector.includes('field-input');
	const isSearch = primitive.baseSelector.includes('search');

	return (
		<S.PrimitivePreview>
			{isInput || isSearch ? (
				<input
					type="text"
					placeholder={isSearch ? 'Search...' : 'Input'}
					style={{
						...inlineStyles,
						width: '100%',
						fontSize: '12px',
						outline: 'none',
					}}
					readOnly
				/>
			) : (
				<div
					style={{
						...inlineStyles,
						width: '100%',
						height: '40px',
						display: 'flex',
						alignItems: 'center',
						paddingLeft: '8px',
						fontSize: '12px',
						color: '#666',
					}}
				>
					Field
				</div>
			)}
		</S.PrimitivePreview>
	);
};
